<template>
  <div class="custom-toast-container">
    <transition-group name="fade" mode="out-in">
      <div v-for="(item, index) in notifications" :key="item.notification_id">
        <div v-if="show" class="panel panel-info alert">
          <div class="custom-toast-header">
            <button type="button" class="close" @click="removeNotification(index)">
              <span aria-hidden="true">&times;</span>
            </button>
            <strong style="font-size: 16px;">{{ item.title }}</strong><br>
          </div>

          <div class="media-body">
            <a :href="item.custom_link ? item.custom_link : '/notificacoes/' + item.notification_id">
              <p style="font-size: 13px;">{{ item.content }}</p>
              <small class="text-muted">{{ item.sender }}</small>
            </a>
          </div>
        </div>
      </div>
    </transition-group>
  </div>

</template>

<script>
//import io from 'socket.io-client';

export default {
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notifications: [],
      show: false,
      //socket: null,
    };
  },
  // async mounted() {
  //   this.fadeIn();

  //   const self = this;

    //self.socket = io(location.host + ':' + process.env.MIX_SOCKET_IO_PORT, {
    //    reconnectionAttempts: 5,
    //    reconnectionDelayMax: 10000,
    //    auth: {
    //        token: await this.getToken()
    //    }
    //});

    //self.socket.on("connect", function (){
    //  self.socket.emit("user_connected", self.currentUser.id);
    //});

    //self.socket.on("connect_error", async () => {
      
      //self.socket.auth.token = await this.getToken();
      
//    });

    //self.socket.on("private-channel:" + self.currentUser.id, function (data) {
      //self.notifications.push(data);
      //self.fadeIn(); // Call the fadeIn method to trigger the transition
      //console.log(self.notifications);
    //});

  //},
  methods: {
    //async getToken() {

      // try {

      //   const response = await axios.get('/users/generate_jwt');
        
      //   return response.data.access_token;

      // } catch (error) {

      //   console.error('Erro ao renovar o token JWT', error);

      // }

    //},
    fadeIn() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    removeNotification(index) {
      this.notifications.splice(index, 1);
    },
  },
};
</script>

<style>
.custom-toast-header {
  border-bottom: 1px solid #c9c9c9;
  padding-bottom: 5px;
  margin-bottom: 7px;
}

.custom-toast-header strong {
  margin-right: 15px;
}

.custom-toast-container {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 9999;
  width: 300px;
  max-width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
